export default "__VITE_ASSET__BUSjFQSW__"